function FormattedDescription({ description }) {
  const descriptionItems = description.split("\n");

  const getColumnClass = (descriptionItem) => {
    if (descriptionItem.includes(":")) {
      return "col-12 fw-bold";
    }

    if (descriptionItem.length > 43) {
      return "col-12";
    }

    return "col-6";
  };

  return (
    <div>
      {descriptionItems?.length > 1 ? (
        <ul className="row">
          {descriptionItems.map((descriptionItem, index) => (
            <li key={index} className={getColumnClass(descriptionItem)}>
              {descriptionItem}
            </li>
          ))}
        </ul>
      ) : (
        <p>{description}</p>
      )}
    </div>
  );
}

export default FormattedDescription;
